import omitBy from "lodash/omitBy";
import uniqBy from "lodash/uniqBy";

const defaultApiKey = "BEGKbPeShVmYq3t6w9zFJ_McQfTjWnZr4u7x-ADG-KaPdRgUkXp2s5";

const usersMinichatUrl = "https://b.minichat.com/api/v1/admin/";
const usersChatruletkaUrl = "https://b.chatruletka.com/api/v1/admin/";

const uniqUsers = (users) => uniqBy(users, (u) => (u.uuid == null ? u : u.uuid));

const mergeByUuidAndTimestamp = (data) => {
  const map = new Map();

  const sumInto = (key, obj) => {
    const prev = map.get(key);
    if (prev) {
      prev.total_hours += obj.total_hours;
      prev.working_hours += obj.working_hours;
      prev.dirty_hours += obj.dirty_hours;
      prev.total_actions += obj.total_actions;
      prev.wage += obj.wage;
      prev.actions_per_hour = prev.total_actions / prev.total_hours;
    } else {
      map.set(key, { ...obj });
    }
  };

  data.forEach((i) => sumInto(`${i.uuid}::${i.timestamp}`, i));

  return Array.from(map.values());
};

const requestApi = (url, options) => {
  return fetch(url, options)
    .then((result) => result.json())
    .catch((error) => ({ error }));
};

export const requestUsers = (apiKey, params = {}) => {
  const processedParams = omitBy(params, (value) => value === null);
  const urlSearchParams = new URLSearchParams({
    ...processedParams,
  }).toString();

  return requestApi(usersMinichatUrl + `admins?${urlSearchParams}`, {
    method: "GET",
    headers: { "X-Api-Key": apiKey || defaultApiKey },
  }).then(({ users: firstBatchOfUsers = [] }) =>
    requestApi(usersChatruletkaUrl + `admins?${urlSearchParams}`, {
      method: "GET",
      headers: { "X-Api-Key": apiKey || defaultApiKey },
    }).then(({ users: secondBatchOfUsers = [] }) =>
      uniqUsers(firstBatchOfUsers.concat(secondBatchOfUsers))
    )
  );
};

export const requestUsersWork = (apiKey, params = {}) => {
  const processedParams = omitBy(params, (value) => value === null);
  const urlSearchParams = new URLSearchParams({
    ...processedParams,
  }).toString();

  return requestApi(
    usersMinichatUrl + `admin_action_summaries?${urlSearchParams}`,
    {
      method: "GET",
      headers: { "X-Api-Key": apiKey || defaultApiKey },
    }
  ).then(({ adminActionSummaries: firstBatchOfData = [] }) =>
    requestApi(
      usersChatruletkaUrl + `admin_action_summaries?${urlSearchParams}`,
      {
        method: "GET",
        headers: { "X-Api-Key": apiKey || defaultApiKey },
      }
    ).then(({ adminActionSummaries: secondBatchOfData = [] }) =>
      mergeByUuidAndTimestamp(firstBatchOfData.concat(secondBatchOfData))
    )
  );
};
